<template>
  <div>
    <!-- {{filterPayload}} -->
    <!-- <pre>{{studentAttendanceList}}</pre> -->
    <vs-card class="cstm_vx_card">
      <div slot="header">
        <h4 v-if="!$route.params.clientObject">All Students List</h4>
      </div>

      <div
        slot="header"
        class="flex items-center mb-4"
        v-if="$route && $route.params && $route.params.clientObject"
      >
        <vs-button
          type="border"
          @click="$router.push({ name: 'attendance' }).catch(() => {})"
          icon="chevron_left"
        ></vs-button>
        <!-- {{$route.params}} -->
        <img
          style="width: 40px; height: 40px"
          class="rounded-full shadow-md block ml-2"
          v-if="$route.params.clientObject.picture"
          :src="$route.params.clientObject.picture"
          alt="image"
        />
        <img
          style="width: 40px; height: 40px"
          class="rounded-full shadow-md block ml-2"
          v-else
          src="http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png"
          alt="image"
        />
        <a style="font-weight: 600" class="ml-2">
          <!-- asdadasdasdad -->
          <span v-if="$route.params.clientObject.first_name"
            >{{ $route.params.clientObject.first_name }}
          </span>
          <span v-if="$route.params.clientObject.middle_name"
            >{{ $route.params.clientObject.middle_name }}
          </span>
          <span v-if="$route.params.clientObject.last_name">{{
            $route.params.clientObject.last_name
          }}</span>
        </a>
      </div>

      <ag-grid-vue
        ref="agGridTable"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :style="{ minHeight: studentAttendanceList.length * 48 + 75 + 'px' }"
        :gridOptions="gridOptions"
        :animateRows="true"
        :floatingFilter="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :columnDefs="studentAttendanceListColumnDefs"
        :rowData="studentAttendanceList"
        @grid-ready="onGridReady"
      />
      <div class="sm:flex justify-between items-center">
        <ItemsPerTableDropdown
          tableName="student_attendance_list"
          @change="(pageLimit) => pageLimitSet = pageLimit"
        />
        <pagination
          :meta="attendance_meta"
          @page-change="handlePageChange"
          class="cstm_pagination"
          style="float: right"
        />
      </div>
    </vs-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import AttendanceNameCell from '../table_components/AttendanceNameCell.vue'
import AttendanceCell from '../table_components/AttendanceCell.vue'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import Pagination from '@/components/common/pagination'
import { attendanceMixin } from '../mixins/attendanceMixin'

import { markAttendence } from '@/api/calenderAction.js'

import { fetchStudentAttendance } from '@/api/dashboard.js'

export default {
  mixins: [attendanceMixin, PermissionMiddleware],
  props: {
    filterPayload: {
      type: Object,
      required: true
    }
  },
  components: {
    AgGridVue,
    AttendanceNameCell,
    AttendanceCell,
    Pagination
  },
  data () {
    return {
      customer_id: localStorage.getItem('customer_id'),
      pageLimitSet: null,
      attendance_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      gridOptions: {},
      gridApi: null,
      studentAttendanceList: [],
      studentAttendanceListColumnDefs: []
    }
  },
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Attendance')
    }
    this.fetchSingle()
  },
  mounted () {
    if (!this.$route.params.clientObject) {
      this.studentAttendanceListColumnDefs.push({
        headerName: 'Student Name',
        field: 'student_name',
        cellRendererFramework: Vue.extend(AttendanceNameCell)
      })
    }

    this.studentAttendanceListColumnDefs.push(
      {
        headerName: 'Course Name',
        field: 'course_name',
        valueFormatter: (params) => params.data.course.name
      },
      {
        headerName: 'Date',
        field: 'schedule_date',
        // eslint-disable-next-line no-confusing-arrow
        //valueFormatter: params => this.$route.params.clientObject ? this.$options.filters.dateFormatLocalization(params.data.schedule_date) : this.$options.filters.dateFormatLocalization(params.data.start_date)
        valueFormatter: (params) => this.$options.filters.dateFormatLocalization(
          params.data.schedule_date
        )
      },
      {
        headerName: 'Attendance',
        field: 'attendance',
        minwidth: '500',
        cellRendererFramework: Vue.extend(AttendanceCell),
        CellRendererParams: {
          leavingMouse: (data) => this.leavingMouse(data),
          //edit_permission: () => this.edit_permission(),
          markingAttendance: (a) => this.markingAttendance(a),
          editAttendance: (data) => this.editAttendance(data),
          checkMarkAttendanceModule: () => this.checkMarkAttendanceModule(),
          isStudentList: true
        }
      }
    )
  },
  methods: {
    handlePageChange (page) {
      if (!this.pageLimitSet) return
      this.attendance_meta.current_page = page
      this.fetchSingle()
    },
    leavingMouse (attendanceInfo) {
      if (
        typeof attendanceInfo.attendance === 'boolean' &&
        !attendanceInfo.attendance
      ) {
        attendanceInfo.attendance = true
      }
    },
    presenCheck () {},
    editAttendance (attendanceInfo) {
      attendanceInfo.attendance = false
    },
    delayedFunc (index) {
      index.delayed_input = false
    },
    async fetchSingle () {
      try {
        this.$vs.loading({ text: 'Fetching Attendance List' })
        const payload = {
          start_date: this.$moment(this.filterPayload.start_date).format(
            'YYYY-MM-DD'
          ),
          end_date: this.$moment(this.filterPayload.end_date).format(
            'YYYY-MM-DD'
          ),
          course_id: this.filterPayload.course_id,
          client_user_id: this.filterPayload.client_user_id || null,
          search: this.filterPayload.search || ''
        }
        this.attendance_meta.limit = this.pageLimitSet
        const { data } = await fetchStudentAttendance(
          this.customer_id,
          payload,
          this.attendance_meta
        )
        this.studentAttendanceList = data.data.students
        this.attendance_meta = data.data.meta
        this.$vs.loading.close()
      } catch (error) {
        console.warn(error)
      } finally {
        this.$vs.loading.close()
      }
    },
    eachStudentNotMarkedData (studentList, attendanceList) {
      const student = []
      const attendanceGivenCombination = attendanceList.map((ele) => {
        return `${ele.client_user_id}${ele.course_id}${this.$moment(
          ele.attendance_date
        ).format('YYYY-MM-DD')}`
      })
      studentList.forEach((ele) => {
        ele.schedule_date.forEach((eachScheduleDate) => {
          const stringChecking = `${ele.client_user_id}${
            ele.course_id
          }${this.$moment(eachScheduleDate).format('YYYY-MM-DD')}`

          if (
            this.$moment(
              this.$moment(eachScheduleDate).format('YYYY-MM-DD')
            ).isBetween(
              this.$moment(this.filterPayload.start_date).format('YYYY-MM-DD'),
              this.$moment(this.filterPayload.end_date).format('YYYY-MM-DD')
            )
          ) {
            if (!attendanceGivenCombination.includes(stringChecking)) {
              student.push({ ...ele, schedule_date: eachScheduleDate })
            }
          }
        })
        // true
      })

      return student
    },
    async structuredStandardList (studentList) {
      return studentList.map((ele) => {
        return {
          attendance_id: null,
          id: ele.client_user_id,
          attendance: true,
          delay_in_minutes: 0,
          name: `${ele.first_name} ${ele.last_name}`,
          picture: `${ele.picture}`
        }
      })
    },
    markingAttendance (attendanceObject, type, event) {
      const payload = {
        course_id: attendanceObject.course_id,
        schedule_id: attendanceObject.id,
        unique_id: attendanceObject.unique_id,

        attendance_date: this.$route.params.clientObject
          ? this.$moment(attendanceObject.schedule_date).format('YYYY-MM-DD')
          : this.$moment(this.filterPayload.start_date).format('YYYY-MM-DD'),
        clients: [
          {
            client_user_id: attendanceObject.client_user_id,
            attendance: attendanceObject.attendance,
            delay_in_minutes: attendanceObject.delay_in_minutes
          }
        ]
      }

      const res = markAttendence(this.customer_id, payload).then((res) => {
        if (res.status === 201) {
          this.showSuccessMessage(
            'Success',
            res.data.message,
            'success'
          )
        }
      })

      if (type === 'delayed') {
        if (
          attendanceObject.delay_in_minutes > 1 &&
          attendanceObject.delay_in_minutes <= 120
        ) {
          if (
            event &&
            'keyCode' in event &&
            event.keyCode === 13 &&
            type === 'delayed'
          ) {
            attendanceObject.attendance_marked = true
          }
        } else {
          this.showSuccessMessage(
            'Error',
            'Attendance must be between 1 And 120',
            'danger'
          )
        }
      }
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  },
  directives: {},
  watch: {
    pageLimitSet () {
      this.handlePageChange(1)
    },
    filterPayload: {
      deep: true,
      handler () {
        this.fetchSingle()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>